export default "__VITE_ASSET__DHs8m90r__"